import React from "react";
import { RenderKilogramo } from "../../../../../../../Utils/renderField/renderReadField";

export const InventariosHistoricosTable = ({ inventarios = [] }) => {
    // Listado de almacenes para columnas. Va antes de salir por falta de datos
    // porque el hook tiene que ejecutarse en todos los renders: si la consulta
    // pasa de no traer periodos a traerlos, React ve una cantidad distinta de
    // hooks y truena
    const almacenes = React.useMemo(() => {
        const map = new Map();

        inventarios.forEach((periodo) => {
            periodo.almacenes.forEach((a) => {
                if (!map.has(a.clave)) {
                    map.set(a.clave, a);
                }
            });
        });

        return Array.from(map.values());
    }, [inventarios]);

    if (!inventarios.length) {
        return (
            <div className="text-center py-5">
                <h3>No hay datos disponibles</h3>
            </div>
        );
    }

    // =========================
    // DETECTAR REAJUSTES
    // =========================
    const tieneReajustes = (periodo) => {
        return periodo.almacenes.some((a) => a.reajustado);
    };

    // =========================
    // RENDER FILA
    // =========================
    const renderFila = (label, key, periodo, rowClassName) => {
        return (
            <tr className={rowClassName}>
                <td className="text-nowrap">{label}</td>

                {almacenes.map((almacenGlobal) => {
                    const a = periodo.almacenes.find(
                        (x) => x.clave === almacenGlobal.clave,
                    );

                    const value = a ? a[key] || 0 : 0;

                    return (
                        <td
                            key={almacenGlobal.clave}
                            className="text-right text-nowrap"
                        >
                            <RenderKilogramo value={value} decimalScale={3} />
                        </td>
                    );
                })}

                <td className="text-right fw-bold text-nowrap cell-border-left">
                    <RenderKilogramo
                        value={periodo.totales[key]}
                        decimalScale={3}
                    />
                </td>
            </tr>
        );
    };

    return (
        <div className="new-table-wrapper my-4 sticky-header sticky-first-column sticky-title-rows">
            <table className="table-striped-v2">
                {/* ================= HEADER ================= */}
                <thead>
                    <tr>
                        <th>Almacen / Materia Prima</th>

                        {almacenes.map((a) => (
                            <th key={a.clave}>
                                <div className="d-flex flex-column">
                                    <span className="text-nowrap">
                                        {a.nombre}
                                    </span>
                                    <span className="text-nowrap">
                                        {a.materia_prima}
                                    </span>
                                </div>
                            </th>
                        ))}

                        <th className="cell-border-left">Totales</th>
                    </tr>
                </thead>

                {/* ================= BODY ================= */}
                <tbody>
                    {inventarios.map((periodo, idx) => {
                        const hayReajustes = tieneReajustes(periodo);

                        return (
                            <React.Fragment key={idx}>
                                {/* ===== TITULO PERIODO ===== */}
                                <tr className="bg-light sticky-title-row">
                                    <td
                                        colSpan={almacenes.length + 2}
                                        className="cell-border-top cell-border-bottom"
                                    >
                                        <strong>{periodo.periodo}</strong>
                                    </td>
                                </tr>

                                {/* ===== INVENTARIO INICIAL ORIGINAL LAB ===== */}
                                {hayReajustes
                                    ? renderFila(
                                          "Inventario inicial original lab",
                                          "lab_inicial_original",
                                          periodo,
                                          "tachado",
                                      )
                                    : renderFila(
                                          "Inventario inicial lab",
                                          "lab_inicial",
                                          periodo,
                                      )}

                                {/* ===== INVENTARIO INICIAL ORIGINAL LIQ ===== */}
                                {hayReajustes
                                    ? renderFila(
                                          "Inventario inicial original liq",
                                          "liq_inicial_original",
                                          periodo,
                                          "tachado",
                                      )
                                    : renderFila(
                                          "Inventario inicial liq",
                                          "liq_inicial",
                                          periodo,
                                      )}

                                {/* ===== INVENTARIO INICIAL REAJUSTE LAB ===== */}
                                {hayReajustes &&
                                    renderFila(
                                        "Inventario inicial reajustado lab",
                                        "lab_inicial",
                                        periodo,
                                        "reporte-inventarios__inv-reajustado-cell",
                                    )}

                                {/* ===== INVENTARIO INICIAL REAJUSTE LIQ ===== */}
                                {hayReajustes &&
                                    renderFila(
                                        "Inventario inicial reajustado liq",
                                        "liq_inicial",
                                        periodo,
                                        "reporte-inventarios__inv-reajustado-cell",
                                    )}

                                {/* ===== INGRESOS LAB ===== */}
                                {renderFila(
                                    "Ingresos LAB",
                                    "lab_ingresos",
                                    periodo,
                                )}

                                {/* ===== INGRESOS LIQ ===== */}
                                {renderFila(
                                    "Ingresos LIQ",
                                    "liq_ingresos",
                                    periodo,
                                )}

                                {/* ===== FINAL LAB ===== */}
                                {renderFila(
                                    "Inventario final lab",
                                    "lab_final",
                                    periodo,
                                )}

                                {/* ===== FINAL LIQ ===== */}
                                {renderFila(
                                    "Inventario final liq",
                                    "liq_final",
                                    periodo,
                                )}

                                {/* ===== ENVIADO LAB ===== */}
                                {renderFila(
                                    "Enviado a producción lab",
                                    "lab_enviado",
                                    periodo,
                                    "reporte-inventarios__enviado-prod-row",
                                )}

                                {/* ===== ENVIADO LIQ ===== */}
                                {renderFila(
                                    "Enviado a producción liq",
                                    "liq_enviado",
                                    periodo,
                                    "reporte-inventarios__enviado-prod-row",
                                )}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
